
const digest = 'f55e5a4c11981b3488f1262e5313f54c2325e4fa2f702a41b994eae2574ed922';
const classes = {"wrapper":"_wrapper_66szz_1","title":"_title_66szz_6","isOpen":"_isOpen_66szz_32"};
const css = `._wrapper_66szz_1 {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
._wrapper_66szz_1 ._title_66szz_6 {
  color: #3C3F9C;
  font-weight: 600;
  font-size: 14px;
  position: relative;
  cursor: pointer;
}
._wrapper_66szz_1 ._title_66szz_6::after {
  content: "";
  width: 33px;
  height: 33px;
  font-weight: 900;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 0;
  background-color: #eaf2ff;
  background-image: url("/dist/patientV3/icons/chevron-right-purple.svg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 12px;
  border-radius: 15px;
  transform: rotate(90deg);
  position: absolute;
  top: -10px;
}
._wrapper_66szz_1 ._title_66szz_6._isOpen_66szz_32::after {
  transform: rotate(-90deg);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  